document.addEventListener('DOMContentLoaded', function () {
  function trackVariantChangeEvent(e) {
    let variant_details = e['detail']['variant'];
    if (variant_details) {
      window.color_options = {
        option2: variant_details['option2'],
        option3: variant_details['option3'],
      };
    }
  }

  function getNavigationUrl(handle) {
    if (!handle) return;
    let url = '/products/' + handle;
    if (typeof window.color_options != 'undefined' && typeof window.color_products != 'undefined') {
      for (let i = 0; i < window.color_products.length; i++) {
        let pro = window.color_products[i];
        let color_options = window.color_options;
        if (pro['handle'] === handle && pro['variants']) {
          for (let j = 0; j < pro['variants'].length; j++) {
            let vari = pro['variants'][j];
            if (color_options['option2'] === vari['option2'] && color_options['option3'] === vari['option3']) {
              url += '?variant=' + vari['id'];

              document.dispatchEvent(
                new CustomEvent('previous:product:variant', {
                  detail: { currentVariant: vari['id'], variantData: pro['variants'], product_variant: pro['id'] },
                })
              );

              break;
            }
          }
          break;
        }
      }
    }
    return url;
  }

  document.addEventListener('product:variant:changed', trackVariantChangeEvent);

  document.querySelectorAll('input[data-color-swatch]').forEach(function (radio) {
    radio.onchange = function () {
      let handle = this.getAttribute('data-procuct-handle');
      document.removeEventListener('product:variant:changed', trackVariantChangeEvent);
      let url = getNavigationUrl(handle);
      if (url) {
        window.location.assign(url);
      }
    };
  });
});
